import { Pipe, PipeTransform } from "@angular/core";
import { toDate } from "src/app/shared/utils/date.util";

@Pipe({
	name: "suffixAndAbbreviatedDate"
})
export class SuffixAndAbbreviatedDatePipe implements PipeTransform {
	transform(value: Date | string): string {
		return this.formatDate(value);
	}

	private formatDate(date: Date | string): string {
		const parsedDate = this.parseAsUtc(date);
		if (Number.isNaN(parsedDate.getTime())) return "";

		const formattedDate = parsedDate;
		const monthParts = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", month: "long" }).formatToParts(
			formattedDate
		);
		let month: string = monthParts.find(part => part.type === "month")?.value ?? "";

		if (month.length > 5) {
			month = month.substring(0, 3);
		}

		const day: string = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", day: "numeric" }).format(formattedDate);
		const hour: string = this.formatHour(formattedDate);

		return `${month[0].toUpperCase() + month.substring(1).toLowerCase()} ${this.formatDay(day)} / ${hour}`;
	}

	// Backend timestamps without an offset are UTC; native parsing would treat them as local time.
	private parseAsUtc(value: Date | string): Date {
		if (typeof value === "string") {
			const trimmed = value.trim();
			if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
				return toDate(trimmed);
			}
			if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(trimmed)) {
				return new Date(`${trimmed}Z`);
			}
		}
		return toDate(value);
	}

	private formatHour(date: Date): string {
		let hours: number = date.getUTCHours();
		let minutes: string | number = date.getUTCMinutes();
		const ampm: string = hours >= 12 ? "PM" : "AM";

		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		hours = String(hours)[0] === "0" ? Number(String(hours)[1]) : hours; // Remove first 0

		minutes = minutes < 10 ? "0" + minutes : minutes;
		minutes = minutes === "00" ? "" : ":" + minutes; // 00 don't show

		return hours + minutes + " " + ampm;
	}

	private formatDay(day: string): string {
		switch (day) {
			case "1":
			case "21":
			case "31":
				return day + "st";
			case "2":
			case "22":
				return day + "nd";
			case "3":
			case "23":
				return day + "rd";
			default:
				return day + "th";
		}
	}
}
